
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 13 11"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{staticClass:"st0",attrs:{"d":"M5.868 10.594c.42 0 .774-.144 1.062-.432.3-.3.45-.657.45-1.071 0-.414-.15-.765-.45-1.053L5.742 6.85h5.436c.42 0 .774-.147 1.062-.441s.432-.645.432-1.053c0-.42-.147-.777-.441-1.071s-.645-.441-1.053-.441H5.742L6.93 2.656c.3-.3.45-.657.45-1.071S7.23.82 6.93.532c-.3-.3-.654-.45-1.062-.45s-.762.15-1.062.45L0 5.356l4.806 4.806c.288.288.642.432 1.062.432z"}})])
          )
        }
      }
    